module.exports = __webpack_public_path__ + "img/gaurantee.2b19d24c.png";